const stateDefault =  [];

export default (state = stateDefault, action) => {
  switch (action.type){
    case 'GET_FOOTER_BANNERS_SUCCESS':
      return action.payload ;
    default:
      return state;
  }
};
